import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/modules/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SigningService } from '@app/certificates/signing/signing.service';
import { BusinessComponent } from './business.component';
import { BusinessSigningComponent } from './business-signing/business-signing.component';
import { BusinessRoutingModule } from './business-routing.module';
import { BusinessProfileComponent } from './business-profile/business-profile.component';
import { BusinessHistoryComponent } from './business-history/business-history.component';
import { MatTableHelper } from '@app/shared/helpers/table-filter.helper';
import { BusinessUserComponent } from './business-user/business-user.component';
import { BusinessUsersTableComponent } from './business-users-table/business-users-table.component';
import { BusinessGroupComponent } from './business-group/business-group.component';
import { CertificatesModule } from '@app/certificates/certificates.module';
import { BusinessSigningHistoryComponent } from './business-history/business-signing-history/business-signing-history.component';
import { BusinessRequestedHistoryComponent } from './business-history/business-requested-history/business-requested-history.component';
import { HistoryDetailsComponent } from './history-details/history-details.component';
import { BusinessFileSettingsComponent } from './business-file-settings/business-file-settings.component';
import { VisualSignaturePositionComponent } from './visual-signature-position/visual-signature-position.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NumberedPaginationComponent } from '@app/core/numbered-pagination/numbered-pagination.component';
import { IdentificationComponent } from './identification/identification.component';
import { BusinessIdentificationComponent } from './business-history/business-identification/business-identification.component';
import { MaskEgnPipe } from '@app/shared/mask-egn.pipe';
import { WebDentificationComponent } from './identification/web-dentification/web-dentification.component';
import { BusinessWebIndentificationComponent } from './business-history/business-web-indentification/business-web-indentification.component';
import { BusinessSigningOtcComponent } from './business-signing-otc/business-signing-otc.component';
import { CloudWebIdentificationHistoryDetailsComponent } from './business-history/cloud-web-identification-history-details/cloud-web-identification-history-details.component';
import { BusinessDownloadService } from './business-download.service';
import { BusinessInCopyHistoryComponent } from './business-history/business-in-copy-history/business-in-copy-history.component';
import { ParcelSigningComponent } from './business-signing/parcel-signing/parcel-signing.component';
import { RegisteredMailSigningComponent } from './business-signing/registered-mail-signing/registered-mail-signing.component';
import { ManagmentHardwareCertificatesComponent } from './business-hardware-certificates/managment-hardware-certificates/managment-hardware-certificates.component';
import { BusinessHardwareCertificatesReportsComponent } from './business-hardware-certificates/business-hardware-certificates-reports/business-hardware-certificates-reports.component';
import { BusinessManagementRequestsReportQESComponent } from './business-hardware-certificates/business-management-requests-report-qes/business-management-requests-report-qes.component';
import { BusinessManagementRequestsReportQesTableComponent } from './business-hardware-certificates/business-management-requests-report-qes/business-management-requests-report-qes-table/business-management-requests-report-qes-table.component';
import { CertificateHistoryComponent } from './business-hardware-certificates/certificate-history/certificate-history.component';
import { BusinessReportsComponent } from './business-reports/business-reports.component';
import { BusinessRegisteredCompanyUsersComponent } from './business-reports/business-registered-company-users/business-registered-company-users.component';
import { BusinessHardwareCertificatesTableComponent } from './business-hardware-certificates/business-hardware-certificates-table/business-hardware-certificates-table.component';
import { BusinessHardwareCertificatesComponent } from './business-hardware-certificates/business-hardware-certificates.component';


@NgModule({
  imports: [
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    BusinessRoutingModule,
    CertificatesModule,
    PdfViewerModule,
  ],
  declarations: [
    BusinessComponent,
    BusinessSigningComponent,
    BusinessProfileComponent,
    BusinessHistoryComponent,
    BusinessUserComponent,
    BusinessUsersTableComponent,
    BusinessGroupComponent,
    BusinessHistoryComponent,
    BusinessSigningHistoryComponent,
    BusinessRequestedHistoryComponent,
    HistoryDetailsComponent,
    BusinessFileSettingsComponent,
    VisualSignaturePositionComponent,
    NumberedPaginationComponent,
    IdentificationComponent,
    BusinessIdentificationComponent,
    MaskEgnPipe,
    WebDentificationComponent,
    BusinessWebIndentificationComponent,
    BusinessSigningOtcComponent,
    CloudWebIdentificationHistoryDetailsComponent,
    BusinessHardwareCertificatesComponent,
    BusinessHardwareCertificatesTableComponent,
    MaskEgnPipe,
    ParcelSigningComponent,
    RegisteredMailSigningComponent,
    ManagmentHardwareCertificatesComponent,
    BusinessInCopyHistoryComponent,
    BusinessHardwareCertificatesReportsComponent,
    BusinessManagementRequestsReportQESComponent,
    BusinessManagementRequestsReportQesTableComponent,
    CertificateHistoryComponent,
    BusinessInCopyHistoryComponent,
    BusinessReportsComponent,
    BusinessRegisteredCompanyUsersComponent
  ],
  providers: [SigningService, MatTableHelper, BusinessDownloadService],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class BusinessModule { }
